
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Brain, HeartPulse, Sparkles } from 'lucide-react';

export interface WellnessActivity {
  name: string;
  date: string;
  impact: 'Positive' | 'Negative';
}

interface WellnessActivitiesProps {
  recentActivities: WellnessActivity[];
  onResetModalOpen: () => void;
}

const WellnessActivities: React.FC<WellnessActivitiesProps> = ({ 
  recentActivities,
  onResetModalOpen
}) => {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-xl">Wellness Activities</CardTitle>
        <CardDescription>Boost your mental health</CardDescription>
      </CardHeader>
      
      <CardContent className="space-y-4">
        <div>
          <h3 className="text-sm font-medium mb-2">Recent Activities</h3>
          <div className="space-y-2">
            {recentActivities.map((activity, index) => (
              <div key={index} className="p-3 border rounded-md flex justify-between items-center">
                <div>
                  <p className="font-medium text-sm">{activity.name}</p>
                  <p className="text-xs text-muted-foreground">{activity.date}</p>
                </div>
                <Badge 
                  variant="outline" 
                  className={activity.impact === 'Positive' 
                    ? 'bg-emerald-500/10 text-emerald-500 border-emerald-500/30'
                    : 'bg-rose-500/10 text-rose-500 border-rose-500/30'
                  }
                >
                  {activity.impact}
                </Badge>
              </div>
            ))}
          </div>
        </div>
        
        <div className="space-y-2">
          <h3 className="text-sm font-medium">Suggested Activities</h3>
          <Button 
            className="w-full mental-reset-button"
            onClick={onResetModalOpen}
          >
            <Sparkles className="h-4 w-4" />
            Start Creative Reset Session
          </Button>
          <Button 
            variant="outline"
            className="w-full"
          >
            <Brain className="h-4 w-4 mr-2" />
            5-Minute Mindfulness
          </Button>
          <Button 
            variant="outline"
            className="w-full"
          >
            <HeartPulse className="h-4 w-4 mr-2" />
            Schedule Tech-Free Break
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default WellnessActivities;
